export default "__VITE_ASSET__CJNnTMKL__"